import React from 'react';
import { Tag, Tooltip } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { isValidDate, renderCustomerServiceStatus } from '@/utils/helpers';

const tagStyle = {
    fontSize: 12,
    fontWeight: 500,
};

const ServiceInfoCell = ({ service, status, type, selectedAt, onNameClick, nameTooltip, showType = true }) => {
    const serviceName = service?.name || '—';

    const renderTypeTag = () => {
        if (type === 'QUANTAM') {
            return <Tag color="#ffb406" style={tagStyle}>Dịch vụ quan tâm</Tag>;
        }
        if (type === 'CHOT') {
            return <Tag color="#03C03C" style={tagStyle}>Dịch vụ chốt</Tag>;
        }
        return <Tag>—</Tag>;
    };

    return (
        <div style={{ lineHeight: 1.5 }}>
            {/* ===== TÊN DỊCH VỤ ===== */}
            <Tooltip title={onNameClick ? nameTooltip : null}>
                <div
                    className={onNameClick ? 'color-primary item-action-btn' : undefined}
                    style={{ fontWeight: 600, fontSize: 14, color: onNameClick ? undefined : '#262626' }}
                    onClick={onNameClick}
                >
                    {serviceName}
                </div>
            </Tooltip>

            {/* ===== TAGS ===== */}
            {(showType || status) && <div style={{ marginTop: 4 }}>
                {showType && renderTypeTag()}

                {status && (
                    <>{renderCustomerServiceStatus(status)}</>
                )}
            </div>}

            {/* ===== NGÀY CHỐT (nếu có) ===== */}
            {selectedAt && (
                <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 4 }}>
                    <ClockCircleOutlined style={{ marginRight: 4 }} />
                    Ngày chốt: {isValidDate(selectedAt, false)}
                </div>
            )}
        </div>
    );
};

export default ServiceInfoCell;
